import {LayoutModes} from './bay-plan-root.visual-part';
import {ZoomLevel} from './bay-plan-dimensions';

export class LayoutZoom {
  constructor(public layoutMode: string = LayoutModes.VESSEL_LAYOUT, public zoomLevel = ZoomLevel.L1) {}
}
